import { getTurnstileToken } from "@/lib/turnstile";

/** GET-based streaming download for the /assay/* endpoints (PubChem/ChEMBL/BindingDB). */
export async function streamDownloadGet(
  path: string,
  defaultFilename: string,
): Promise<void> {
  const baseUrl = (import.meta.env.VITE_API_BASE_URL as string) ?? "";
  const turnstileToken = await getTurnstileToken();
  const response = await fetch(`${baseUrl}/${path}`, {
    headers: { "cf-turnstile-token": turnstileToken },
  });

  if (!response.ok) {
    throw new Error(
      `Download failed: ${response.status} ${response.statusText}`,
    );
  }

  const reader = response.body!.getReader();
  const chunks: Uint8Array[] = [];

  while (true) {
    const { done, value } = await reader.read();
    if (done) break;
    chunks.push(value);
  }

  const disposition = response.headers.get("Content-Disposition");
  const filename =
    disposition
      ?.split(";")
      .find((s) => s.trim().startsWith("filename="))
      ?.split("=")[1]
      ?.replace(/['"]/g, "")
      .trim() ?? defaultFilename;

  const blob = new Blob(chunks as BlobPart[], {
    type: "text/csv;charset=utf-8;",
  });
  const url = URL.createObjectURL(blob);
  const link = document.createElement("a");
  link.href = url;
  link.download = filename;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  URL.revokeObjectURL(url);
}
